@if (initialized) {
  @if (!accounts.length) {
    <div class="mat-body-strong">
      <p></p>
      Found no records to show
    </div>
  }
  @if (accounts.length) {
    <div class="cards-container">
      @for (account of accounts; track account) {
        <div class="link stroked-card">
          <div class="line">
            <div class="mat-body-strong capitalize">{{account.name}}</div>
          </div>
          <!-- Contact information on the same line -->
          <div class="contact-info">
            <div class="contact-row">
              <div class="contact-item">
                <mat-icon color="primary">email</mat-icon>
                <span>{{account.email}}</span>
              </div>
              <div class="contact-item">
                <mat-icon color="primary">phone</mat-icon>
                <span>{{account.phone}}</span>
              </div>
            </div>
          </div>
          <!-- Only show role for current project -->
          @if (account.roles && getCurrentProjectRole(account)) {
            <div class="mat-caption">
              <div class="role">
                <span>{{getCurrentProjectRole(account)}}</span>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
  @if (initialized && pagination.length && accounts.length) {
    <mat-paginator (page)="pageChanged($event)"
      [length]="pagination.length" [pageIndex]="pagination.pageIndex" [pageSize]="pagination.pageSize">
    </mat-paginator>
  }
}
